import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, styled } from '@mui/material'
import moment from 'moment'
import useSubcomponents from 'useSubcomponents'
import { MUIDateTimePicker } from 'packages/eid-ui/DateTimePickers'

const TextButtonContainer = styled(Box)({
    color: '#307fc1',
    fontSize: '13px',
    display: 'flex',
    alignItems: 'center',
    zIndex: 10,
    minWidth: '110px',
    paddingLeft: '16px',
    '&:hover': {
        cursor: 'pointer',
        textDecoration: 'underline',
    },
    margin: '0px 8px',
})

const styles = {
    fulfillmentScheduleDateControl: {
        fontSize: '12px',
        lineHeight: 1.33,
        color: '#9b9b9b',
        textTransform: 'uppercase',
        minWidth: '204px',
        display: 'block',
        wordBreak: 'break-word',
        wordWrap: 'break-word',
        fontWeight: 'bold',
    },
}

export const FulfillmentScheduleDateControl = ({
    item,
    withOutLabel,
    onEdit,
}) => {
    const { t } = useTranslation()

    const {
        hasAccessToFulfillmentScheduleDateControl,
        hasAccessToEditFulfillmentScheduleDateControl,
    } = useSubcomponents()

    const [
        selectedFulfillmentScheduleDate,
        setSelectedFulfillmentScheduleDate,
    ] = useState(
        item?.fulFillmentScheduleDateUtc
            ? moment.utc(item.fulFillmentScheduleDateUtc)
            : null,
    )

    const [checked, setChecked] = useState(false)

    const fulfillmentScheduleDateControlReadOnly = (
        <Box
            data-protectedsubcomponent={
                hasAccessToFulfillmentScheduleDateControl
            }
            marginY="7.5px"
            display="flex"
            alignItems="center"
        >
            {selectedFulfillmentScheduleDate
                ? selectedFulfillmentScheduleDate.clone().local().format('LLL')
                : null}
        </Box>
    )

    const isReadOnly =
        hasAccessToFulfillmentScheduleDateControl &&
        item.fulFillmentScheduleDateUtc
    const isEditableFulfillmentScheduleDate =
        hasAccessToFulfillmentScheduleDateControl &&
        hasAccessToEditFulfillmentScheduleDateControl &&
        item.fulFillmentScheduleDateUtc &&
        item.isFulFillmentScheduleDateEditable

    const handleSave = () => {
        setChecked((prev) => !prev)
        onEdit({
            fulFillmentScheduleDateUtc: selectedFulfillmentScheduleDate.utc(),
        })
    }

    const fulfillmentScheduleDateControlEditable = (
        <Box display="flex" alignItems="center">
            {checked ? (
                <MUIDateTimePicker
                    dateTimeFormat="lll"
                    minDate={moment(new Date())}
                    handleChange={(e) => {
                        const date = moment(e)
                        setSelectedFulfillmentScheduleDate(date)
                    }}
                    value={selectedFulfillmentScheduleDate.local() || null}
                    fieldProps={{
                        sx: {
                            marginTop: '0px !important',
                        },
                    }}
                />
            ) : (
                fulfillmentScheduleDateControlReadOnly
            )}

            {!checked ? (
                <TextButtonContainer
                    onClick={() => setChecked((prev) => !prev)}
                >
                    {t('Edit')}
                </TextButtonContainer>
            ) : (
                <TextButtonContainer onClick={handleSave}>
                    {t('Save')}
                </TextButtonContainer>
            )}
        </Box>
    )

    return (
        <>
            {!withOutLabel && (
                <Box
                    marginY="7.5px"
                    alignItems="center"
                    style={styles.fulfillmentScheduleDateControl}
                    data-protectedsubcomponent={`${hasAccessToFulfillmentScheduleDateControl} OR ${hasAccessToEditFulfillmentScheduleDateControl}`}
                >
                    {(isReadOnly || isEditableFulfillmentScheduleDate) &&
                        t('FulfillmentScheduleDate')}
                </Box>
            )}

            <Box>
                {isReadOnly &&
                    !isEditableFulfillmentScheduleDate &&
                    fulfillmentScheduleDateControlReadOnly}
                {isEditableFulfillmentScheduleDate &&
                    fulfillmentScheduleDateControlEditable}
            </Box>
        </>
    )
}
